import { MobileMPU } from '@public/components/Ads/MobileMPU';
import { MPU } from '@public/components/Ads/MPU';
import { DraftByStarsLegend } from '@public/components/DraftByStars/DraftByStarsLegend';
import { DraftHistoryLegend } from '@public/components/DraftByStars/DraftHistoryLegend';
import styles from '@public/components/Layouts/StandardSidebar.module.scss';
import { useRouter } from 'next/router';

export const DatabaseSidebar = () => {
  const router = useRouter();
  const isDraftByStars = router.asPath.includes('draft-by-stars');
  const isDraftClassByYear = router.asPath.includes('draft-by-year');

  return (
    <aside className={styles.sidebar}>
      <MPU id="mpu_top" />
      <MobileMPU id="mobile_mpu_bottom" incontent />
      {isDraftByStars && <DraftByStarsLegend />}
      {isDraftClassByYear && <DraftHistoryLegend />}
      <MPU id="mpu_middle" />
    </aside>
  );
};
